<section class="card">
  <header class="fraud-panel-heading">
    <h2>جزئیات پرونده<span *ngIf="caseId"> شماره {{ caseId | faNum }}</span></h2>
    <div class="actions">
      <span *ngIf="detail" class="tag" [ngClass]="detail.reviewClass">{{ detail.reviewLabel }}</span>
      <a class="btn btn-ghost" routerLink="../cases">بازگشت به پرونده‌ها <i class="fa fa-arrow-left" aria-hidden="true"></i></a>
    </div>
  </header>
  <div *ngIf="!detail" class="body fraud-state-body">
    <div *ngIf="loading" class="loader show"><div class="spinner"></div><span>در حال دریافت جزئیات...</span></div>
    <div *ngIf="!loading && error" class="state show error">
      <i class="fa fa-exclamation-triangle ico-big" aria-hidden="true"></i>
      <p>{{ error }}</p>
      <button class="btn btn-ghost" type="button" (click)="retry.emit()">تلاش دوباره</button>
    </div>
    <div *ngIf="!loading && !error" class="state show">
      <i class="fa fa-folder-open-o ico-big" aria-hidden="true"></i>
      <p>{{ caseId ? 'پرونده یافت نشد یا دسترسی به آن وجود ندارد.' : 'ابتدا یک پرونده را از فهرست انتخاب کنید.' }}</p>
      <a class="btn btn-ghost" routerLink="../cases">مشاهده پرونده‌ها</a>
    </div>
  </div>
  <div *ngIf="detail as item" class="fraud-detail-grid">
    <div>
      <span>خودروی اول</span>
      <strong>{{ item.strFullName1 || '—' }}</strong>
      <p class="fraud-vehicle-meta">موبایل: <bdi dir="ltr">{{ item.strMobile1 || '—' | faNum }}</bdi></p>
      <p class="fraud-vehicle-meta">پلاک: <bdi>{{ item.strVehicleNo1 || '—' | faNum }}</bdi></p>
    </div>
    <div>
      <span>خودروی دوم</span>
      <strong>{{ item.strFullName2 || '—' }}</strong>
      <p class="fraud-vehicle-meta">موبایل: <bdi dir="ltr">{{ item.strMobile2 || '—' | faNum }}</bdi></p>
      <p class="fraud-vehicle-meta">پلاک: <bdi>{{ item.strVehicleNo2 || '—' | faNum }}</bdi></p>
    </div>
    <div><span>شروع بازه</span><strong><bdi dir="rtl">{{ formatDate(item.dtStartDate) | faNum }}</bdi></strong></div>
    <div><span>پایان بازه</span><strong><bdi dir="rtl">{{ formatDate(item.dtEndDate) | faNum }}</bdi></strong></div>
    <div><span>بیشترین امتیاز</span><strong>{{ (item.fFraudScore | number:'1.2-2') ?? '—' | faNum }}</strong></div>
    <div><span>میانگین امتیاز</span><strong>{{ (item.fAverageSimilarityScore | number:'1.2-2') ?? '—' | faNum }}</strong></div>
    <div><span>کمترین امتیاز</span><strong>{{ (item.fMinSimilarityScore | number:'1.2-2') ?? '—' | faNum }}</strong></div>
    <div><span>مدت حرکت مشترک</span><strong>{{ item.iCommonMovementMinutes | number | faNum }} دقیقه</strong></div>
  </div>
</section>
